import {type FilterProvider, FilterQueryParser, unescapeString} from '@github-ui/filter-core'

import {createParserProvider} from './create-parser-provider'
import type {QuerySegment} from './types'

const keyPattern = new RegExp(/([\w.#-]+):/g)
export const MAX_QUERY_LENGTH = 1000

export function tokenizeQuery(query: string, providers?: FilterProvider[]): QuerySegment[] {
  if (query.length > MAX_QUERY_LENGTH) {
    // If the query is too long, avoid parsing to prevent a DoS attack. - rule `js/polynomial-redos`
    return [
      {
        type: 'text',
        value: query,
      },
    ]
  }

  if (!providers) {
    // Identify potential keys to create providers needed for parsing
    const keys = Array.from(query.matchAll(keyPattern), match => match[1] || '').filter(Boolean)
    providers = keys.map(key => createParserProvider(key, {}))
  }

  const parser = new FilterQueryParser(providers)

  return parser
    .parse(query)
    .blocks.filter(block => block.type !== 'space')
    .map<QuerySegment>(block => {
      if (block.type === 'filter') {
        const isNegated = block.key.value.startsWith('-')
        const key = isNegated ? block.key.value.slice(1) : block.key.value
        const sanitizeValues = block.value.values.map(({value}) => {
          return typeof value === 'string' ? (unescapeString(value) ?? value) : `${value}`
        })

        return {
          type: 'filter',
          key,
          isNegated,
          values: sanitizeValues,
          quotedValues: block.value.values.map(({value}) => `${value}`),
          raw: block.raw,
        }
      } else {
        return {type: 'text', value: block.raw}
      }
    })
}
